/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body?: AuthenticateRequest | undefined): Promise<AuthenticateResponseResponse> {
        let url_ = this.baseUrl + "/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthenticateResponseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResponseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResponseResponse>(null as any);
    }

    /**
     * @return Success
     */
    refreshToken(): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    revokeToken(body?: RevokeTokenRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/revoke-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRevokeToken(_response);
        });
    }

    protected processRevokeToken(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body?: RegisterRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEmail(body?: VerifyEmailRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/verify-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body?: ForgotPasswordRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateResetToken(body?: ValidateResetTokenRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/validate-reset-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateResetToken(_response);
        });
    }

    protected processValidateResetToken(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body?: ResetPasswordRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @return Success
     */
    accountAll(): Promise<AccountResponse[]> {
        let url_ = this.baseUrl + "/api/Account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountAll(_response);
        });
    }

    protected processAccountAll(response: Response): Promise<AccountResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accountPOST(body?: CreateRequest | undefined): Promise<AccountResponseResponse> {
        let url_ = this.baseUrl + "/api/Account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountPOST(_response);
        });
    }

    protected processAccountPOST(response: Response): Promise<AccountResponseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountResponseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountResponseResponse>(null as any);
    }

    /**
     * @return Success
     */
    accountGET(id: number): Promise<AccountResponseResponse> {
        let url_ = this.baseUrl + "/api/Account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountGET(_response);
        });
    }

    protected processAccountGET(response: Response): Promise<AccountResponseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountResponseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountResponseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accountPUT(id: number, body?: UpdateRequest | undefined): Promise<AccountResponseResponse> {
        let url_ = this.baseUrl + "/api/Account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountPUT(_response);
        });
    }

    protected processAccountPUT(response: Response): Promise<AccountResponseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountResponseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountResponseResponse>(null as any);
    }

    /**
     * @return Success
     */
    accountDELETE(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountDELETE(_response);
        });
    }

    protected processAccountDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    accountUpdate(id?: number | undefined, body?: UpdateRequest | undefined): Promise<AccountResponseResponse> {
        let url_ = this.baseUrl + "/api/Account/AccountUpdate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountUpdate(_response);
        });
    }

    protected processAccountUpdate(response: Response): Promise<AccountResponseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountResponseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountResponseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPage(body?: UserPaginationModel | undefined): Promise<UserPaginationItemPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Account/GetPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: Response): Promise<UserPaginationItemPaginationResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPaginationItemPaginationResultResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPaginationItemPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setStatus(body?: EnityStatusModel | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/SetStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetStatus(_response);
        });
    }

    protected processSetStatus(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateRole(id?: number | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/UpdateRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRole(_response);
        });
    }

    protected processUpdateRole(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    chagnePassword(body?: ChangePasswordModel | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Account/ChagnePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChagnePassword(_response);
        });
    }

    protected processChagnePassword(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilePage(body?: FilePaginationModel | undefined): Promise<FilePaginationItemPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/File/GetFilePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilePage(_response);
        });
    }

    protected processGetFilePage(response: Response): Promise<FilePaginationItemPaginationResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilePaginationItemPaginationResultResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilePaginationItemPaginationResultResponse>(null as any);
    }

    /**
     * @param parentId (optional) 
     * @param id (optional) 
     * @param fileType (optional) 
     * @param name (optional) 
     * @param formFile (optional) 
     * @param downloadUrl (optional) 
     * @return Success
     */
    saveFile(parentId?: number | undefined, id?: number | undefined, fileType?: number | undefined, name?: string | undefined, formFile?: FileParameter | undefined, downloadUrl?: string | undefined ,onUploadProgress?: any): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/File/SaveFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (parentId === null || parentId === undefined)
            console.log("The parameter 'parentId' cannot be null.");
        else
            content_.append("ParentId", parentId.toString());
        if (id === null || id === undefined)
            console.log("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (fileType === null || fileType === undefined)
            throw new Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (formFile === null || formFile === undefined)
            throw new Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            },
            onUploadProgress
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveFile(_response);
        });
    }

    protected processSaveFile(response: Response): Promise<FileFolderItemResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileFolderItemResultResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileFolderItemResultResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFileDetails(id?: number | undefined): Promise<FileModelResponse> {
        let url_ = this.baseUrl + "/api/File/GetFileDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileDetails(_response);
        });
    }

    protected processGetFileDetails(response: Response): Promise<FileModelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileModelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setFileStatus(body?: EnityStatusModel | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/File/SetFileStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFileStatus(_response);
        });
    }

    protected processSetFileStatus(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameFile(body?: NamedEntityModel | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/File/RenameFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenameFile(_response);
        });
    }

    protected processRenameFile(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveFile(body?: FileFolderMoveRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/File/MoveFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveFile(_response);
        });
    }

    protected processMoveFile(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPage2(body?: FolderPaginationModel | undefined): Promise<FileFolderItemPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Folder/GetPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPage2(_response);
        });
    }

    protected processGetPage2(response: Response): Promise<FileFolderItemPaginationResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileFolderItemPaginationResultResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileFolderItemPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFolder(body?: SaveFolderModel | undefined): Promise<FileFolderItemResultResponse> {
        let url_ = this.baseUrl + "/api/Folder/SaveFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveFolder(_response);
        });
    }

    protected processSaveFolder(response: Response): Promise<FileFolderItemResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileFolderItemResultResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileFolderItemResultResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param search (optional) 
     * @return Success
     */
    getFileFolderDetails(id?: number | undefined, search?: string | undefined): Promise<FilePaginationItemIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Folder/GetFileFolderDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileFolderDetails(_response);
        });
    }

    protected processGetFileFolderDetails(response: Response): Promise<FilePaginationItemIEnumerableResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilePaginationItemIEnumerableResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilePaginationItemIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setFolderStatus(body?: EnityStatusModel | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Folder/SetFolderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFolderStatus(_response);
        });
    }

    protected processSetFolderStatus(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFolderPath(id?: number | undefined): Promise<FolderPathModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Folder/GetFolderPath?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFolderPath(_response);
        });
    }

    protected processGetFolderPath(response: Response): Promise<FolderPathModelIEnumerableResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FolderPathModelIEnumerableResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderPathModelIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameFolder(body?: NamedEntityModel | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Folder/RenameFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenameFolder(_response);
        });
    }

    protected processRenameFolder(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveFolder(body?: FileFolderMoveRequest | undefined): Promise<DevResponse> {
        let url_ = this.baseUrl + "/api/Folder/MoveFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain",
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveFolder(_response);
        });
    }

    protected processMoveFolder(response: Response): Promise<DevResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevResponse>(null as any);
    }

    /**
     * @param parentId (optional) 
     * @param id (optional) 
     * @param fileType (optional) 
     * @param name (optional) 
     * @param formFile (optional) 
     * @param downloadUrl (optional) 
     * @return Success
     */
    upload(parentId?: number | undefined, id?: number | undefined, fileType?: number | undefined, name?: string | undefined, formFile?: FileParameter | undefined, downloadUrl?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Storage/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (parentId === null || parentId === undefined)
            throw new Error("The parameter 'parentId' cannot be null.");
        else
            content_.append("ParentId", parentId.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (fileType === null || fileType === undefined)
            throw new Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (formFile === null || formFile === undefined)
            throw new Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (downloadUrl === null || downloadUrl === undefined)
            throw new Error("The parameter 'downloadUrl' cannot be null.");
        else
            content_.append("DownloadUrl", downloadUrl.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Authorization":getToken()?.valueOf()
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    values(): Promise<void> {
        let url_ = this.baseUrl + "/api/Values";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValues(_response);
        });
    }

    protected processValues(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}
type AccountGETQueryParameters = {
      id: number;
};

type GetFileDetailsQueryParameters = {
      id?: number | undefined;
};

type GetFileFolderDetailsQueryParameters = {
      id?: number | undefined;
      search?: string | undefined;
};

type GetFolderPathQueryParameters = {
      id?: number | undefined;
};

export class Query{

    get baseUrl() {
      return getBaseUrl() ?? '' + '';
    }

    static get Client() {
        return createClient(Client);
    }

    static get Url() {
        return new Query();
    }
                

    accountAll(): string {
      let url_ = this.baseUrl + "/api/Account";
    url_ = url_.replace(/[?&]$/, "");
      return url_;
    }

    static accountAllDefaultOptions?: UseQueryOptions<AccountResponse[], unknown, AccountResponse[]> = {};
    public static accountAllQueryKey(): QueryKey;
    public static accountAllQueryKey(...params: any[]): QueryKey {
        return removeUndefinedFromArrayTail([
            'Client',
            'accountAll',
            ]);
        
    }

    private static accountAll() {
        return Query.Client.accountAll(
            );
    }

    /**
     * @return Success
     */
    static useAccountAllQuery<TSelectData = AccountResponse[], TError = unknown>(options?: UseQueryOptions<AccountResponse[], TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    static useAccountAllQuery<TSelectData = AccountResponse[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {

        let options: UseQueryOptions<AccountResponse[], TError, TSelectData> | undefined = undefined;
        

        options = params[0] as any;
    

        return useQuery<AccountResponse[], TError, TSelectData>({
            queryFn: Query.accountAll,
            queryKey: Query.accountAllQueryKey(),
            ...Query.accountAllDefaultOptions as unknown as UseQueryOptions<AccountResponse[], TError, TSelectData>,
            ...options,
        });
    }
    /**
     * @return Success
     */
    static setAccountAllData(queryClient: QueryClient, updater: (data: AccountResponse[] | undefined) => AccountResponse[], ) {
        queryClient.setQueryData(Query.accountAllQueryKey(),
            updater
        );
    }

    /**
     * @return Success
     */
    static setAccountAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: AccountResponse[] | undefined) => AccountResponse[]) {
        queryClient.setQueryData(queryKey, updater);
    }
      

    accountGET(id: number): string {
      let url_ = this.baseUrl + "/api/Account/{id}";
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");
      return url_;
    }

    static accountGETDefaultOptions?: UseQueryOptions<AccountResponseResponse, unknown, AccountResponseResponse> = {};
    public static accountGETQueryKey(id: number): QueryKey;
    public static accountGETQueryKey(...params: any[]): QueryKey {

        if (params.length === 1 && isParameterObject(params[0])) {
            const { id,  } = params[0] as AccountGETQueryParameters;

            return removeUndefinedFromArrayTail([
                'Client',
                'accountGET',
                id as any,
            ]);
        } else {
            return removeUndefinedFromArrayTail([
                'Client',
                'accountGET',
                ...params
            ]);
        }
        
    }

    private static accountGET(context: QueryFunctionContext) {
        return Query.Client.accountGET(
                context.queryKey[2] as number
            );
    }

    static useAccountGETQuery<TSelectData = AccountResponseResponse, TError = unknown>(dto: AccountGETQueryParameters, options?: UseQueryOptions<AccountResponseResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    /**
     * @return Success
     */
    static useAccountGETQuery<TSelectData = AccountResponseResponse, TError = unknown>(id: number, options?: UseQueryOptions<AccountResponseResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    static useAccountGETQuery<TSelectData = AccountResponseResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {

        let options: UseQueryOptions<AccountResponseResponse, TError, TSelectData> | undefined = undefined;
        let id: any = undefined;
        
        if (params.length > 0) {
            if (isParameterObject(params[0])) {
                ({ id,  } = params[0] as AccountGETQueryParameters);
                options = params[1];
            } else {
                [id,  options] = params;
            }
        }
    

        return useQuery<AccountResponseResponse, TError, TSelectData>({
            queryFn: Query.accountGET,
            queryKey: Query.accountGETQueryKey(id),
            ...Query.accountGETDefaultOptions as unknown as UseQueryOptions<AccountResponseResponse, TError, TSelectData>,
            ...options,
        });
    }
    /**
     * @return Success
     */
    static setAccountGETData(queryClient: QueryClient, updater: (data: AccountResponseResponse | undefined) => AccountResponseResponse, id: number) {
        queryClient.setQueryData(Query.accountGETQueryKey(id),
            updater
        );
    }

    /**
     * @return Success
     */
    static setAccountGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: AccountResponseResponse | undefined) => AccountResponseResponse) {
        queryClient.setQueryData(queryKey, updater);
    }
                      

    getFileDetails(id?: number | undefined): string {
      let url_ = this.baseUrl + "/api/File/GetFileDetails?";
    if (id === null)
        throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
        url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");
      return url_;
    }

    static getFileDetailsDefaultOptions?: UseQueryOptions<FileModelResponse, unknown, FileModelResponse> = {};
    public static getFileDetailsQueryKey(id?: number | undefined): QueryKey;
    public static getFileDetailsQueryKey(...params: any[]): QueryKey {

        if (params.length === 1 && isParameterObject(params[0])) {
            const { id,  } = params[0] as GetFileDetailsQueryParameters;

            return removeUndefinedFromArrayTail([
                'Client',
                'getFileDetails',
                id as any,
            ]);
        } else {
            return removeUndefinedFromArrayTail([
                'Client',
                'getFileDetails',
                ...params
            ]);
        }
        
    }

    private static getFileDetails(context: QueryFunctionContext) {
        return Query.Client.getFileDetails(
                context.queryKey[2] as number | undefined
            );
    }

    static useGetFileDetailsQuery<TSelectData = FileModelResponse, TError = unknown>(dto: GetFileDetailsQueryParameters, options?: UseQueryOptions<FileModelResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    /**
     * @param id (optional) 
     * @return Success
     */
    static useGetFileDetailsQuery<TSelectData = FileModelResponse, TError = unknown>(id?: number | undefined, options?: UseQueryOptions<FileModelResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    static useGetFileDetailsQuery<TSelectData = FileModelResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {

        let options: UseQueryOptions<FileModelResponse, TError, TSelectData> | undefined = undefined;
        let id: any = undefined;
        
        if (params.length > 0) {
            if (isParameterObject(params[0])) {
                ({ id,  } = params[0] as GetFileDetailsQueryParameters);
                options = params[1];
            } else {
                [id,  options] = params;
            }
        }
    

        return useQuery<FileModelResponse, TError, TSelectData>({
            queryFn: Query.getFileDetails,
            queryKey: Query.getFileDetailsQueryKey(id),
            ...Query.getFileDetailsDefaultOptions as unknown as UseQueryOptions<FileModelResponse, TError, TSelectData>,
            ...options,
        });
    }
    /**
     * @param id (optional) 
     * @return Success
     */
    static setGetFileDetailsData(queryClient: QueryClient, updater: (data: FileModelResponse | undefined) => FileModelResponse, id?: number | undefined) {
        queryClient.setQueryData(Query.getFileDetailsQueryKey(id),
            updater
        );
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    static setGetFileDetailsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: FileModelResponse | undefined) => FileModelResponse) {
        queryClient.setQueryData(queryKey, updater);
    }
              

    getFileFolderDetails(id?: number | undefined, search?: string | undefined): string {
      let url_ = this.baseUrl + "/api/Folder/GetFileFolderDetails?";
    if (id === null)
        throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
        url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (search === null)
        throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined)
        url_ += "search=" + encodeURIComponent("" + search) + "&";
    url_ = url_.replace(/[?&]$/, "");
      return url_;
    }

    static getFileFolderDetailsDefaultOptions?: UseQueryOptions<FilePaginationItemIEnumerableResponse, unknown, FilePaginationItemIEnumerableResponse> = {};
    public static getFileFolderDetailsQueryKey(dto: GetFileFolderDetailsQueryParameters): QueryKey;
    public static getFileFolderDetailsQueryKey(id?: number | undefined,search?: string | undefined): QueryKey;
    public static getFileFolderDetailsQueryKey(...params: any[]): QueryKey {

        if (params.length === 1 && isParameterObject(params[0])) {
            const { id, search,  } = params[0] as GetFileFolderDetailsQueryParameters;

            return removeUndefinedFromArrayTail([
                'Client',
                'getFileFolderDetails',
                id as any,
                search as any,
            ]);
        } else {
            return removeUndefinedFromArrayTail([
                'Client',
                'getFileFolderDetails',
                ...params
            ]);
        }
        
    }

    private static getFileFolderDetails(context: QueryFunctionContext) {
        return Query.Client.getFileFolderDetails(
                context.queryKey[2] as number | undefined, 
                context.queryKey[3] as string | undefined
            );
    }

    static useGetFileFolderDetailsQuery<TSelectData = FilePaginationItemIEnumerableResponse, TError = unknown>(dto: GetFileFolderDetailsQueryParameters, options?: UseQueryOptions<FilePaginationItemIEnumerableResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    /**
     * @param id (optional) 
     * @param search (optional) 
     * @return Success
     */
    static useGetFileFolderDetailsQuery<TSelectData = FilePaginationItemIEnumerableResponse, TError = unknown>(id?: number | undefined, search?: string | undefined, options?: UseQueryOptions<FilePaginationItemIEnumerableResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    static useGetFileFolderDetailsQuery<TSelectData = FilePaginationItemIEnumerableResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {

        let options: UseQueryOptions<FilePaginationItemIEnumerableResponse, TError, TSelectData> | undefined = undefined;
        let id: any = undefined;
        let search: any = undefined;
        
        if (params.length > 0) {
            if (isParameterObject(params[0])) {
                ({ id, search,  } = params[0] as GetFileFolderDetailsQueryParameters);
                options = params[1];
            } else {
                [id, search,  options] = params;
            }
        }
    

        return useQuery<FilePaginationItemIEnumerableResponse, TError, TSelectData>({
            queryFn: Query.getFileFolderDetails,
            queryKey: Query.getFileFolderDetailsQueryKey(id, search),
            ...Query.getFileFolderDetailsDefaultOptions as unknown as UseQueryOptions<FilePaginationItemIEnumerableResponse, TError, TSelectData>,
            ...options,
        });
    }
    /**
     * @param id (optional) 
     * @param search (optional) 
     * @return Success
     */
    static setGetFileFolderDetailsData(queryClient: QueryClient, updater: (data: FilePaginationItemIEnumerableResponse | undefined) => FilePaginationItemIEnumerableResponse, id?: number | undefined, search?: string | undefined) {
        queryClient.setQueryData(Query.getFileFolderDetailsQueryKey(id, search),
            updater
        );
    }

    /**
     * @param id (optional) 
     * @param search (optional) 
     * @return Success
     */
    static setGetFileFolderDetailsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: FilePaginationItemIEnumerableResponse | undefined) => FilePaginationItemIEnumerableResponse) {
        queryClient.setQueryData(queryKey, updater);
    }
      

    getFolderPath(id?: number | undefined): string {
      let url_ = this.baseUrl + "/api/Folder/GetFolderPath?";
    if (id === null)
        throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
        url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");
      return url_;
    }

    static getFolderPathDefaultOptions?: UseQueryOptions<FolderPathModelIEnumerableResponse, unknown, FolderPathModelIEnumerableResponse> = {};
    public static getFolderPathQueryKey(id?: number | undefined): QueryKey;
    public static getFolderPathQueryKey(...params: any[]): QueryKey {

        if (params.length === 1 && isParameterObject(params[0])) {
            const { id,  } = params[0] as GetFolderPathQueryParameters;

            return removeUndefinedFromArrayTail([
                'Client',
                'getFolderPath',
                id as any,
            ]);
        } else {
            return removeUndefinedFromArrayTail([
                'Client',
                'getFolderPath',
                ...params
            ]);
        }
        
    }

    private static getFolderPath(context: QueryFunctionContext) {
        return Query.Client.getFolderPath(
                context.queryKey[2] as number | undefined
            );
    }

    static useGetFolderPathQuery<TSelectData = FolderPathModelIEnumerableResponse, TError = unknown>(dto: GetFolderPathQueryParameters, options?: UseQueryOptions<FolderPathModelIEnumerableResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    /**
     * @param id (optional) 
     * @return Success
     */
    static useGetFolderPathQuery<TSelectData = FolderPathModelIEnumerableResponse, TError = unknown>(id?: number | undefined, options?: UseQueryOptions<FolderPathModelIEnumerableResponse, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    static useGetFolderPathQuery<TSelectData = FolderPathModelIEnumerableResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {

        let options: UseQueryOptions<FolderPathModelIEnumerableResponse, TError, TSelectData> | undefined = undefined;
        let id: any = undefined;
        
        if (params.length > 0) {
            if (isParameterObject(params[0])) {
                ({ id,  } = params[0] as GetFolderPathQueryParameters);
                options = params[1];
            } else {
                [id,  options] = params;
            }
        }
    

        return useQuery<FolderPathModelIEnumerableResponse, TError, TSelectData>({
            queryFn: Query.getFolderPath,
            queryKey: Query.getFolderPathQueryKey(id),
            ...Query.getFolderPathDefaultOptions as unknown as UseQueryOptions<FolderPathModelIEnumerableResponse, TError, TSelectData>,
            ...options,
        });
    }
    /**
     * @param id (optional) 
     * @return Success
     */
    static setGetFolderPathData(queryClient: QueryClient, updater: (data: FolderPathModelIEnumerableResponse | undefined) => FolderPathModelIEnumerableResponse, id?: number | undefined) {
        queryClient.setQueryData(Query.getFolderPathQueryKey(id),
            updater
        );
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    static setGetFolderPathDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: FolderPathModelIEnumerableResponse | undefined) => FolderPathModelIEnumerableResponse) {
        queryClient.setQueryData(queryKey, updater);
    }
          

    values(): string {
      let url_ = this.baseUrl + "/api/Values";
    url_ = url_.replace(/[?&]$/, "");
      return url_;
    }

    static valuesDefaultOptions?: UseQueryOptions<void, unknown, void> = {};
    public static valuesQueryKey(): QueryKey;
    public static valuesQueryKey(...params: any[]): QueryKey {
        return removeUndefinedFromArrayTail([
            'Client',
            'values',
            ]);
        
    }

    private static values() {
        return Query.Client.values(
            );
    }

    /**
     * @return Success
     */
    static useValuesQuery<TSelectData = void, TError = unknown>(options?: UseQueryOptions<void, TError, TSelectData>): UseQueryResult<TSelectData, TError>;
    static useValuesQuery<TSelectData = void, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {

        let options: UseQueryOptions<void, TError, TSelectData> | undefined = undefined;
        

        options = params[0] as any;
    

        return useQuery<void, TError, TSelectData>({
            queryFn: Query.values,
            queryKey: Query.valuesQueryKey(),
            ...Query.valuesDefaultOptions as unknown as UseQueryOptions<void, TError, TSelectData>,
            ...options,
        });
    }
    /**
     * @return Success
     */
    static setValuesData(queryClient: QueryClient, updater: (data: void | undefined) => void, ) {
        queryClient.setQueryData(Query.valuesQueryKey(),
            updater
        );
    }

    /**
     * @return Success
     */
    static setValuesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: void | undefined) => void) {
        queryClient.setQueryData(queryKey, updater);
    }
    }

export class AccountResponse implements IAccountResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    role?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isVerified?: boolean;
    jwtToken?: string | undefined;

    constructor(data?: IAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.role = _data["role"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.isVerified = _data["isVerified"];
            this.jwtToken = _data["jwtToken"];
        }
    }

    static fromJS(data: any): AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["role"] = this.role;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isVerified"] = this.isVerified;
        data["jwtToken"] = this.jwtToken;
        return data;
    }
}

export interface IAccountResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    role?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isVerified?: boolean;
    jwtToken?: string | undefined;
}

export class AccountResponseResponse implements IAccountResponseResponse {
    success?: boolean;
    statusCode?: number | undefined;
    message?: string | undefined;
    data?: AccountResponse;

    constructor(data?: IAccountResponseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? AccountResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountResponseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResponseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountResponseResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: AccountResponse;
}

export class AuthenticateRequest implements IAuthenticateRequest {
    email!: string;
    password!: string;
    isRemember!: boolean;

    constructor(data?: IAuthenticateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticateRequest {
    email: string;
    password: string;
    isRemember:boolean;
}

export class AuthenticateResponse implements IAuthenticateResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    role?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isVerified?: boolean;
    jwtToken?: string | undefined;

    constructor(data?: IAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.role = _data["role"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.isVerified = _data["isVerified"];
            this.jwtToken = _data["jwtToken"];
        }
    }

    static fromJS(data: any): AuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["role"] = this.role;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isVerified"] = this.isVerified;
        data["jwtToken"] = this.jwtToken;
        return data;
    }
}

export interface IAuthenticateResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    role?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isVerified?: boolean;
    jwtToken?: string | undefined;
}

export class AuthenticateResponseResponse implements IAuthenticateResponseResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: AuthenticateResponse;

    constructor(data?: IAuthenticateResponseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? AuthenticateResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthenticateResponseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthenticateResponseResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: AuthenticateResponse;
}

export class ChangePasswordModel implements IChangePasswordModel {
    currentPassword!: string;
    newPassword!: string;
    confirmNewPassword!: string;

    constructor(data?: IChangePasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IChangePasswordModel {
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
}

export class CreateRequest implements ICreateRequest {
    firstName!: string;
    lastName!: string;
    role!: string;
    email!: string;
    userName!: string;
    password!: string;

    constructor(data?: ICreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateRequest {
    firstName: string;
    lastName: string;
    role: string;
    email: string;
    userName: string;
    password: string;
}

export class EnityStatusModel implements IEnityStatusModel {
    id?: number;
    status?: number;

    constructor(data?: IEnityStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EnityStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnityStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IEnityStatusModel {
    id?: number;
    status?: number;
}

export class FileFolderItem implements IFileFolderItem {
    parentId?: number;
    id?: number;
    name?: string | undefined;
    fileType?: number;
    fileName?: string | undefined;
    displayName?: string | undefined;
    downloadUrl?: string | undefined;
    type?: number;
    status?: number;

    constructor(data?: IFileFolderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
            this.downloadUrl = _data["downloadUrl"];
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FileFolderItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileFolderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        data["downloadUrl"] = this.downloadUrl;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface IFileFolderItem {
    parentId?: number;
    id?: number;
    name?: string | undefined;
    fileType?: number;
    fileName?: string | undefined;
    displayName?: string | undefined;
    downloadUrl?: string | undefined;
    type?: number;
    status?: number;
}

export class FileFolderItemPaginationResult implements IFileFolderItemPaginationResult {
    totalElementsCount?: number;
    totalPages?: number;
    currentPage?: number;
    data?: FileFolderItem[] | undefined;

    constructor(data?: IFileFolderItemPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalElementsCount = _data["totalElementsCount"];
            this.totalPages = _data["totalPages"];
            this.currentPage = _data["currentPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileFolderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileFolderItemPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new FileFolderItemPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalElementsCount"] = this.totalElementsCount;
        data["totalPages"] = this.totalPages;
        data["currentPage"] = this.currentPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileFolderItemPaginationResult {
    totalElementsCount?: number;
    totalPages?: number;
    currentPage?: number;
    data?: FileFolderItem[] | undefined;
}

export class FileFolderItemPaginationResultResponse implements IFileFolderItemPaginationResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FileFolderItemPaginationResult;

    constructor(data?: IFileFolderItemPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? FileFolderItemPaginationResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileFolderItemPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileFolderItemPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileFolderItemPaginationResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FileFolderItemPaginationResult;
}



export class FileFolderItemResult implements IFileFolderItemResult {
    parentId?: number;
    id?: number;
    name?: string | undefined;
    fileType?: number;
    fileName?: string | undefined;
    displayName?: string | undefined;
    downloadUrl?: string | undefined;
    type?: number;
    status?: number;

    constructor(data?: IFileFolderItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
            this.downloadUrl = _data["downloadUrl"];
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FileFolderItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new FileFolderItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        data["downloadUrl"] = this.downloadUrl;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface IFileFolderItemResult {
    parentId?: number;
    id?: number;
    name?: string | undefined;
    fileType?: number;
    fileName?: string | undefined;
    displayName?: string | undefined;
    downloadUrl?: string | undefined;
    type?: number;
    status?: number;
}




export class FileFolderItemResultResponse implements IFileFolderItemResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FileFolderItemResult;

    constructor(data?: IFileFolderItemResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? FileFolderItemResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileFolderItemResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileFolderItemResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileFolderItemResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FileFolderItemResult;
}


export class FileFolderMoveRequest implements IFileFolderMoveRequest {
    id?: number;
    parentId?: number | undefined;
    destinationParentId?: number | undefined;

    constructor(data?: IFileFolderMoveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.destinationParentId = _data["destinationParentId"];
        }
    }

    static fromJS(data: any): FileFolderMoveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileFolderMoveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["destinationParentId"] = this.destinationParentId;
        return data;
    }
}

export interface IFileFolderMoveRequest {
    id?: number;
    parentId?: number | undefined;
    destinationParentId?: number | undefined;
}

export class FileModel implements IFileModel {
    parentId?: number | undefined;
    id?: number | undefined;
    fileType?: number;
    name?: string | undefined;
    formFile?: string | undefined;
    downloadUrl?: string | undefined;

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = -1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.id = _data["id"] !== undefined ? _data["id"] : -1;
            this.fileType = _data["fileType"];
            this.name = _data["name"];
            this.formFile = _data["formFile"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["fileType"] = this.fileType;
        data["name"] = this.name;
        data["formFile"] = this.formFile;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IFileModel {
    parentId?: number | undefined;
    id?: number | undefined;
    fileType?: number;
    name?: string | undefined;
    formFile?: string | undefined;
    downloadUrl?: string | undefined;
}

export class FileModelResponse implements IFileModelResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FileModel;

    constructor(data?: IFileModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? FileModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileModelResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FileModel;
}

export class FilePaginationItem implements IFilePaginationItem {
    parentId?: number;
    id?: number;
    name?: string | undefined;
    fileType?: number;
    fileName?: string | undefined;
    displayName?: string | undefined;
    downloadUrl?: string | undefined;
    type?: number;
    status?: number;

    constructor(data?: IFilePaginationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
            this.downloadUrl = _data["downloadUrl"];
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FilePaginationItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilePaginationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        data["downloadUrl"] = this.downloadUrl;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface IFilePaginationItem {
    parentId?: number;
    id?: number;
    name?: string | undefined;
    fileType?: number;
    fileName?: string | undefined;
    displayName?: string | undefined;
    downloadUrl?: string | undefined;
    type?: number;
    status?: number;
}

export class FilePaginationItemIEnumerableResponse implements IFilePaginationItemIEnumerableResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FilePaginationItem[] | undefined;

    constructor(data?: IFilePaginationItemIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilePaginationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilePaginationItemIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilePaginationItemIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilePaginationItemIEnumerableResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FilePaginationItem[] | undefined;
}

export class FilePaginationItemPaginationResult implements IFilePaginationItemPaginationResult {
    totalPages?: number;
    currentPage?: number;
    activeIndex?: number;
    totalElementsCount?: number;
    data?: FilePaginationItem[] | undefined;

    constructor(data?: IFilePaginationItemPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.currentPage = _data["currentPage"];
            this.activeIndex = _data["activeIndex"];
            this.totalElementsCount = _data["totalElementsCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilePaginationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilePaginationItemPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilePaginationItemPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["currentPage"] = this.currentPage;
        data["activeIndex"] = this.activeIndex;
        data["totalElementsCount"] = this.totalElementsCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilePaginationItemPaginationResult {
    totalPages?: number;
    currentPage?: number;
    activeIndex?: number;
    totalElementsCount?: number;
    data?: FilePaginationItem[] | undefined;
}

export class FilePaginationItemPaginationResultResponse implements IFilePaginationItemPaginationResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FilePaginationItemPaginationResult;

    constructor(data?: IFilePaginationItemPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? FilePaginationItemPaginationResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilePaginationItemPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilePaginationItemPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFilePaginationItemPaginationResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FilePaginationItemPaginationResult;
}

export class FilePaginationModel implements IFilePaginationModel {
    platform?: number;
    takeCount?: number;
    page?: number;
    activeIndex?: number;
    orderIndex?: number;
    numberOfElements?: number;
    orderDescending?: boolean;
    navigationProperties?: string[] | undefined;
    parentId?: number;

    constructor(data?: IFilePaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.takeCount = _data["takeCount"];
            this.page = _data["page"];
            this.activeIndex = _data["activeIndex"];
            this.orderIndex = _data["orderIndex"];
            this.numberOfElements = _data["numberOfElements"];
            this.orderDescending = _data["orderDescending"];
            if (Array.isArray(_data["navigationProperties"])) {
                this.navigationProperties = [] as any;
                for (let item of _data["navigationProperties"])
                    this.navigationProperties!.push(item);
            }
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FilePaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilePaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["takeCount"] = this.takeCount;
        data["page"] = this.page;
        data["activeIndex"] = this.activeIndex;
        data["orderIndex"] = this.orderIndex;
        data["numberOfElements"] = this.numberOfElements;
        data["orderDescending"] = this.orderDescending;
        if (Array.isArray(this.navigationProperties)) {
            data["navigationProperties"] = [];
            for (let item of this.navigationProperties)
                data["navigationProperties"].push(item);
        }
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFilePaginationModel {
    platform?: number;
    takeCount?: number;
    page?: number;
    activeIndex?: number;
    orderIndex?: number;
    numberOfElements?: number;
    orderDescending?: boolean;
    navigationProperties?: string[] | undefined;
    parentId?: number;
}

export class FolderPaginationModel implements IFolderPaginationModel {
    platform?: number;
    takeCount?: number;
    page?: number;
    activeIndex?: number;
    orderIndex?: number;
    numberOfElements?: number;
    orderDescending?: boolean;
    navigationProperties?: string[] | undefined;
    id?: number | undefined;
    search?: string | undefined;

    constructor(data?: IFolderPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.takeCount = _data["takeCount"];
            this.page = _data["page"];
            this.activeIndex = _data["activeIndex"];
            this.orderIndex = _data["orderIndex"];
            this.numberOfElements = _data["numberOfElements"];
            this.orderDescending = _data["orderDescending"];
            if (Array.isArray(_data["navigationProperties"])) {
                this.navigationProperties = [] as any;
                for (let item of _data["navigationProperties"])
                    this.navigationProperties!.push(item);
            }
            this.id = _data["id"];
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): FolderPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FolderPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["takeCount"] = this.takeCount;
        data["page"] = this.page;
        data["activeIndex"] = this.activeIndex;
        data["orderIndex"] = this.orderIndex;
        data["numberOfElements"] = this.numberOfElements;
        data["orderDescending"] = this.orderDescending;
        if (Array.isArray(this.navigationProperties)) {
            data["navigationProperties"] = [];
            for (let item of this.navigationProperties)
                data["navigationProperties"].push(item);
        }
        data["id"] = this.id;
        data["search"] = this.search;
        return data;
    }
}

export interface IFolderPaginationModel {
    platform?: number;
    takeCount?: number;
    page?: number;
    activeIndex?: number;
    orderIndex?: number;
    numberOfElements?: number;
    orderDescending?: boolean;
    navigationProperties?: string[] | undefined;
    id?: number | undefined;
    search?: string | undefined;
}

export class FolderPathModel implements IFolderPathModel {
    id?: number;
    parentId?: number | undefined;
    name?: string | undefined;
    level?: number;

    constructor(data?: IFolderPathModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): FolderPathModel {
        data = typeof data === 'object' ? data : {};
        let result = new FolderPathModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["level"] = this.level;
        return data;
    }
}

export interface IFolderPathModel {
    id?: number;
    parentId?: number | undefined;
    name?: string | undefined;
    level?: number;
}

export class FolderPathModelIEnumerableResponse implements IFolderPathModelIEnumerableResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FolderPathModel[] | undefined;

    constructor(data?: IFolderPathModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FolderPathModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FolderPathModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FolderPathModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFolderPathModelIEnumerableResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: FolderPathModel[] | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export class NamedEntityModel implements INamedEntityModel {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: INamedEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NamedEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new NamedEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INamedEntityModel {
    id?: number | undefined;
    name?: string | undefined;
}

export class RegisterRequest implements IRegisterRequest {
    firstName!: string;
    lastName!: string;
    role!: Role;
    email!: string;
    userName!: string;
    password!: string;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IRegisterRequest {
    firstName: string;
    lastName: string;
    role: Role;
    email: string;
    userName: string;
    password: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    token!: string;
    password!: string;
    confirmPassword!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IResetPasswordRequest {
    token: string;
    password: string;
    confirmPassword: string;
}

export class DevResponse implements IDevResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;

    constructor(data?: IDevResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DevResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DevResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IDevResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
}

export class RevokeTokenRequest implements IRevokeTokenRequest {
    token?: string | undefined;

    constructor(data?: IRevokeTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RevokeTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IRevokeTokenRequest {
    token?: string | undefined;
}

export enum Role {
    Admin = 0,
    User = 1,
}
export enum FileFolderType {
    File = 0,
    Folder = 1,
}
export class SaveFolderModel implements ISaveFolderModel {
    parentId?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    status?: number;

    constructor(data?: ISaveFolderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.parentId = 0;
            this.id = -1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : 0;
            this.id = _data["id"] !== undefined ? _data["id"] : -1;
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SaveFolderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFolderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface ISaveFolderModel {
    parentId?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    status?: number;
}

export class UpdateRequest implements IUpdateRequest {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IUpdateRequest {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export class UserPaginationItem implements IUserPaginationItem {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: number;

    constructor(data?: IUserPaginationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserPaginationItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaginationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["role"] = this.role;
        return data;
    }
}

export interface IUserPaginationItem {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: number;
}

export class UserPaginationItemPaginationResult implements IUserPaginationItemPaginationResult {
    totalPages?: number;
    currentPage?: number;
    activeIndex?: number;
    totalElementsCount?: number;
    data?: UserPaginationItem[] | undefined;

    constructor(data?: IUserPaginationItemPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPages = _data["totalPages"];
            this.currentPage = _data["currentPage"];
            this.activeIndex = _data["activeIndex"];
            this.totalElementsCount = _data["totalElementsCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserPaginationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPaginationItemPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaginationItemPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        data["currentPage"] = this.currentPage;
        data["activeIndex"] = this.activeIndex;
        data["totalElementsCount"] = this.totalElementsCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserPaginationItemPaginationResult {
    totalPages?: number;
    currentPage?: number;
    activeIndex?: number;
    totalElementsCount?: number;
    data?: UserPaginationItem[] | undefined;
}

export class UserPaginationItemPaginationResultResponse implements IUserPaginationItemPaginationResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: UserPaginationItemPaginationResult;

    constructor(data?: IUserPaginationItemPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.data = _data["data"] ? UserPaginationItemPaginationResult.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserPaginationItemPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaginationItemPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserPaginationItemPaginationResultResponse {
    success?: boolean;
    statusCode?: number;
    message?: string | undefined;
    data?: UserPaginationItemPaginationResult;
}

export class UserPaginationModel implements IUserPaginationModel {
    platform?: number;
    takeCount?: number;
    page?: number;
    activeIndex?: number;
    orderIndex?: number;
    numberOfElements?: number;
    orderDescending?: boolean;
    navigationProperties?: string[] | undefined;
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IUserPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.takeCount = _data["takeCount"];
            this.page = _data["page"];
            this.activeIndex = _data["activeIndex"];
            this.orderIndex = _data["orderIndex"];
            this.numberOfElements = _data["numberOfElements"];
            this.orderDescending = _data["orderDescending"];
            if (Array.isArray(_data["navigationProperties"])) {
                this.navigationProperties = [] as any;
                for (let item of _data["navigationProperties"])
                    this.navigationProperties!.push(item);
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserPaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["takeCount"] = this.takeCount;
        data["page"] = this.page;
        data["activeIndex"] = this.activeIndex;
        data["orderIndex"] = this.orderIndex;
        data["numberOfElements"] = this.numberOfElements;
        data["orderDescending"] = this.orderDescending;
        if (Array.isArray(this.navigationProperties)) {
            data["navigationProperties"] = [];
            for (let item of this.navigationProperties)
                data["navigationProperties"].push(item);
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserPaginationModel {
    platform?: number;
    takeCount?: number;
    page?: number;
    activeIndex?: number;
    orderIndex?: number;
    numberOfElements?: number;
    orderDescending?: boolean;
    navigationProperties?: string[] | undefined;
    id?: number | undefined;
    name?: string | undefined;
}

export class ValidateResetTokenRequest implements IValidateResetTokenRequest {
    token!: string;

    constructor(data?: IValidateResetTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ValidateResetTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResetTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IValidateResetTokenRequest {
    token: string;
}

export class VerifyEmailRequest implements IVerifyEmailRequest {
    token!: string;

    constructor(data?: IVerifyEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IVerifyEmailRequest {
    token: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

import { useQuery, UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey } from 'react-query';
import { getToken } from '../helpers/util';

function removeUndefinedFromArrayTail<T>(arr: T[]): T[] {
    let lastDefinedValueIndex = arr.length - 1;
    while (lastDefinedValueIndex >= 0) {
        if (arr[lastDefinedValueIndex] === undefined) {
            lastDefinedValueIndex--;
        } else {
            break;
        }
    }
    return lastDefinedValueIndex === arr.length - 1 ? arr : arr.slice(0, lastDefinedValueIndex + 1);
}

/*
  Determines if first parameter of useSomethingQuery is an object with query parameters, or it's a regular parameter
  Returns true if parameter is Object
  Returns false if parameter is number/string/boolean/Date or Array
*/
function isParameterObject(param: unknown) {
    if (param === null || param === undefined) return false;
    if (param instanceof Array) return false;
    const isObject = typeof param === 'object';
    if (!isObject) return false;
    if (param instanceof Date) return false;
    return true;
}

type ClientFactoryFunction = <T>(type: (new (...params: any[]) => T)) => T;
let _clientFactoryFunction: ClientFactoryFunction = <T>(type: (new (...params: any[]) => T)) => {
  const params = [_baseUrl, _fetchFactory()];
  return new type(...params);
};
/*
  Overrides default Client factory function
*/
export function setClientFactory(value: ClientFactoryFunction) {
  _clientFactoryFunction = value;
}

/*
  Returns current Client factory function
*/
export function getClientFactory() {
  return _clientFactoryFunction;
}

/*
  Function that will be called from `useQuery...` methods to get a client of certain type
*/
function createClient<T>(type: (new () => T)) {
  return _clientFactoryFunction(type);
}

let _baseUrl = '';
/*
  Returns the base URL for http requests
*/
export function getBaseUrl(): string {
  return _baseUrl;
}

/*
  Sets the base URL for http requests
*/
export function setBaseUrl(baseUrl: string) {
  _baseUrl = baseUrl;
}

let _fetchFactory = () => <any>window;
/*
  Returns currently used factory for fetch
*/
export function getFetchFactory(): () => { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }  {
  return _fetchFactory;
}
/*
  Sets currently used factory for fetch
*/
export function setFetchFactory(factory: () => { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
  _fetchFactory = factory;
}